import {
  Component, OnInit
} from '@angular/core';
import { Chart } from 'chart.js';
import { MonitoringService } from 'src/app/shared/services/monitoring-service';

@Component({
  selector: 'app-system-status-dashboard',
  templateUrl: './system-status-dashboard.component.html',
  styleUrls: ['./system-status-dashboard.component.css']
})
export class SystemStatusDashboardComponent implements OnInit {

  lastUpdated = "";

  // Summary Cards
  appLines = 0;
  apacheRequests = 0;
  systemLines = 0;
  appErrors = 0;
  highAlerts = 0;

  // Chart Data
  appSeverityLabels: string[] = [];
  appSeverityData: number[] = [];

  apacheCodeLabels: string[] = [];
  apacheCodeData: number[] = [];

  systemSeverityLabels: string[] = [];
  systemSeverityData: number[] = [];

  diskUsageLabels: string[] = [];
  diskUsageData: number[] = [];

  constructor(private monitoring: MonitoringService) {}

  ngOnInit(): void {
    this.lastUpdated = new Date().toLocaleString();

    this.loadAppData();
    this.loadApacheData();
    this.loadSystemData();
  }

  // ==========================
  //  LOAD APP LOG DATA
  // ==========================
  loadAppData() {
    this.monitoring.getApp().subscribe(res => {

      console.log("APP LOG:", res);

      this.appLines = res.totalLines || 0;
      this.appErrors = res.errors || 0;

      // High alerts = "alert" severity
      this.highAlerts = res.severity?.alert || 0;

      // Convert severity map
      this.appSeverityLabels = Object.keys(res.severity || {});
      this.appSeverityData = Object.values(res.severity || {});

      this.renderAppSeverity();
    });
  }

  // ==========================
  //  LOAD APACHE LOG DATA
  // ==========================
  loadApacheData() {
    this.monitoring.getApache().subscribe(res => {

      console.log("APACHE LOG:", res);

      this.apacheRequests = res.totalRequests || 0;

      this.apacheCodeLabels = Object.keys(res.statusCodes || {});
      this.apacheCodeData = Object.values(res.statusCodes || {});

      this.renderApacheCodes();
    });
  }

  // ==========================
  //  LOAD SYSTEM LOG DATA
  // ==========================
  loadSystemData() {
    this.monitoring.getSystem().subscribe(res => {

      console.log("SYSTEM LOG:", res);

      this.systemLines = res.totalLines || 0;

      this.systemSeverityLabels = Object.keys(res.severity || {});
      this.systemSeverityData = Object.values(res.severity || {});

      // Disk details (if provided)
      this.diskUsageLabels = ['Used', 'Free'];
      this.diskUsageData = [
        res.diskUsed || 0,
        res.diskFree || 0
      ];

      this.renderSystemSeverity();
      this.renderDiskUsage();
    });
  }

  // ==========================
  //  CHARTS
  // ==========================

  renderAppSeverity() {
    new Chart('chartAppSeverity', {
      type: 'pie',
      data: {
        labels: this.appSeverityLabels,
        datasets: [{
          data: this.appSeverityData
        }]
      }
    });
  }

  renderApacheCodes() {
    new Chart('chartApacheCodes', {
      type: 'bar',
      data: {
        labels: this.apacheCodeLabels,
        datasets: [{
          label: 'Count',
          data: this.apacheCodeData
        }]
      }
    });
  }

  renderSystemSeverity() {
    new Chart('chartSystemSeverity', {
      type: 'doughnut',
      data: {
        labels: this.systemSeverityLabels,
        datasets: [{
          data: this.systemSeverityData
        }]
      }
    });
  }

  renderDiskUsage() {
    new Chart('chartDiskUsage', {
      type: 'doughnut',
      data: {
        labels: this.diskUsageLabels,
        datasets: [{
          data: this.diskUsageData
        }]
      }
    });
  }
}
